export const AGREEMENT_TYPE = {
  ENTERPRICE: 'enterprise',
  ONE_OFF: 'one_off',
  PASS: 'pass',
  LANDING_TRIAL: 'external_landing_trial'
}

export const BALANCE_LIMIT_TYPE = {
  POOL: 'pool',
}

export const BRANDING_TYPE = {
  ANY: 'any_branding_type',
  BRANDED: 'branded',
}

export const DOWNLOAD_TYPE = {
  FREE: 'free',
  NORMAL: 'normal',
  ONE_OFF: 'one_off',
  REPEATED: 'repeated',
  TOP_UP: 'top_up',
  RESTRICTED: 'restricted',
}

export const LIMIT_TYPE = {
  COMPANY_LIMIT: 'company_limit',
  DAY_LIMIT: 'day_limit',
  NONE: 'none',
  USER_LIMIT: 'user_limit',
}

export const QUOTA_PERIOD = {
  MONTH: 'month',
}

// {
//   can: true,
//   why_not_reason: %i[limit on_request pool_restricted inactive live_restricted],
//   download_type: %i[normal free repeated top_up one_off],
//   allowed_branding_types: %i[clean branded credit],
//   one_off_already_downloaded_branding_types: %i[clean branded],
//   limit_type: %i[day_limit company_limit user_limit none]
// }
